export default __webpack_public_path__ + "static/media/Mask Group 46.2b827b9f.png";